import React from 'react';
import { useTranslation } from '../../../../context/LanguageContext';
import InputField from '../../../form/InputField';

const RestaurantTab = ({ settings, handleChange }) => {
    const { t, isRTL } = useTranslation();

    return (
        <div className="space-y-6">
            <div className="bg-white rounded-lg p-6 shadow-sm">
                <h3 className={`text-lg font-semibold text-gray-800 mb-6 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('admin.restaurantSettings')}
                </h3>
                <div className="grid grid-cols-1 gap-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <InputField
                            label={t('admin.restaurantName')}
                            value={settings.restaurant.name}
                            onChange={(e) => handleChange('restaurant', 'name', e.target.value)}
                        />
                        <InputField
                            label={t('admin.restaurantNameAr')}
                            value={settings.restaurant.name_ar}
                            onChange={(e) => handleChange('restaurant', 'name_ar', e.target.value)}
                        />
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <InputField
                            label={t('admin.phone')}
                            value={settings.restaurant.phone}
                            onChange={(e) => handleChange('restaurant', 'phone', e.target.value)}
                        />
                        <InputField
                            label={t('admin.taxNumber')}
                            value={settings.restaurant.tax_number}
                            onChange={(e) => handleChange('restaurant', 'tax_number', e.target.value)}
                        />
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <InputField
                            label={t('admin.address')}
                            value={settings.restaurant.address}
                            onChange={(e) => handleChange('restaurant', 'address', e.target.value)}
                            type="textarea"
                        />
                        <InputField
                            label={t('admin.addressAr')}
                            value={settings.restaurant.address_ar}
                            onChange={(e) => handleChange('restaurant', 'address_ar', e.target.value)}
                            type="textarea"
                        />
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <InputField
                            label={t('admin.commercialRegistration')}
                            value={settings.restaurant.commercial_registration}
                            onChange={(e) => handleChange('restaurant', 'commercial_registration', e.target.value)}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RestaurantTab;
